import axios from '../script/axiosAMS'

export default {
  getHome (params, resultCallback) {
    axios.requestWith({
      url: '/api/home',
      method: 'get',
      params: params,
      resultCallback: resultCallback
    })
  },
  home (method, data, resultCallback) {
    axios.requestWith({
      url: '/api/home',
      method: method,
      data: data,
      resultCallback: resultCallback
    })
  }
}



// WEBPACK FOOTER //
// ./src/script/amsHome.js